var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 3.59999C2.4 2.93725 2.93726 2.39999 3.6 2.39999H6.18345C6.77006 2.39999 7.27068 2.82409 7.36712 3.40272L8.2543 8.72576C8.3409 9.2454 8.07847 9.76076 7.60728 9.99635L5.74951 10.9252C7.08907 14.254 9.74602 16.9109 13.0748 18.2505L14.0036 16.3927C14.2392 15.9215 14.7546 15.6591 15.2742 15.7457L20.5973 16.6329C21.1759 16.7293 21.6 17.2299 21.6 17.8165V20.4C21.6 21.0627 21.0627 21.6 20.4 21.6H18C9.38436 21.6 2.4 14.6156 2.4 5.99999V3.59999Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.127d537a347febfa92e11caf6d6de37b.svg";
export { ForwardRef as ReactComponent };